import { Injectable } from '@angular/core';
import { Config } from './config';
import { EMPTY, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivateLocationResponse, EchoConfiguration, RainAlertConfiguration } from '../models/monitorsetting';
import { catchError, map, retry } from 'rxjs/operators';
import { ForeSiteULConfigurationPayload } from '../components/location-card/store/configs/foresite-ul/base-api-models';
import { EchoConfigurationPayload } from '../components/location-card/store/configs/echo/base-api-models';
import { RainAlertConfigurationPayload } from '../components/location-card/store/configs/rain-alert/base-api-models';
import { EchoMonitorConfiguration } from '../components/location-card/store/configs/echo/models';
import { RainAlertMonitorConfiguration } from '../components/location-card/store/configs/rain-alert/models';
import { FlexMonitorConfiguration } from '../components/location-card/store/configs/flex/models';
import { ForesiteULMonitorConfiguration } from '../components/location-card/store/configs/foresite-ul/models';
import { ForesiteXDMonitorConfiguration } from '../components/location-card/store/configs/foresite-xd/models';
import { EdgeRlMonitorConfiguration } from '../components/location-card/store/configs/edge-rl/models';
import { EdgeRlConfigurationPayload } from '../components/location-card/store/configs/edge-rl/base-api-models';
import { FlexConfigurationPayload } from '../components/location-card/store/configs/flex/base-api-models';

@Injectable()
export class MonitorSettingService {
    constructor(public http: HttpClient) {}

    public rainAlert(rainAlertConfiguration: RainAlertConfiguration | RainAlertConfigurationPayload, customerID: number) {
        console.log('rainAlertConfiguration', rainAlertConfiguration);
        return this.http
            .post<ActivateLocationResponse>(Config.urls.configureRainAlert + `${customerID}`, rainAlertConfiguration)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public foreSiteUl(configuration: ForeSiteULConfigurationPayload, customerID: number) {
        return this.http
            .post<RainAlertConfiguration>(Config.urls.configureForeSiteUl + `${customerID}`, configuration)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public foreSITEXD(configuration, customerID: number) {
        return this.http
            .post<RainAlertConfiguration>(Config.urls.configureforeSITEXD + `${customerID}`, configuration)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public activateLocation(customerId: number, locationid: number, serialnumber: string, ipaddress: string) {
        return this.http
            .post<ActivateLocationResponse>(
                Config.serviceUrl +
                    Config.urls.activatedMonitor +
                    `${customerId}&LocationID=${locationid}&SerialNumber=${serialnumber}&IPAddress=${ipaddress}`,
                {},
            )
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    return throwError(error);
                }),
                retry(3),
            );
    }

    public echoMonitorConfiguration(echoConfiguration: EchoConfiguration | EchoConfigurationPayload, customerID: number) {
        return this.http.post<ActivateLocationResponse>(Config.urls.configureEchoAlert + `${customerID}`, echoConfiguration).pipe(
            map(
                (result) => {
                    return result;
                },
                () => {
                    return EMPTY;
                },
            ),
        );
    }

    public getRainAlertMonitorConfiguration(customerID: number, locationId: number) {
        return this.http
            .get<RainAlertMonitorConfiguration>(Config.urls.configureRainAlert + `${customerID}` + `&locationId=${locationId}`)
            .pipe(
                map(
                    (result) => {
                        console.log('getRainAlertMonitorConfiguration result', result);
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public getEchoMonitorConfiguration(customerID: number, locationId: number) {
        return this.http
            .get<EchoMonitorConfiguration>(Config.urls.configureEchoAlert + `${customerID}` + `&locationId=${locationId}`)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public foreSiteUlConfiguration(customerID: number, locationId: number) {
        return this.http
            .get<ForesiteULMonitorConfiguration>(Config.urls.configureForeSiteUl + `${customerID}` + `&locationId=${locationId}`)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public getForeSITEXDConfiguration(customerID: number, locationId: number) {
        return this.http
            .get<ForesiteXDMonitorConfiguration>(Config.urls.configureforeSITEXD + `${customerID}` + `&locationId=${locationId}`)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public getFlexConfiguration(customerID: number, locationId: number) {
        return this.http
            .get<FlexMonitorConfiguration>(Config.urls.configureFlex + `${customerID}` + `&lid=${locationId}`)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public flexConfiguration(configuration: FlexConfigurationPayload, customerID: number, locationId: number) {
        return this.http
            .post<FlexMonitorConfiguration>(
                Config.urls.configureFlex + `${customerID}&lid=${locationId}`,
                configuration,
            )
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public getEdgeRlConfiguration(customerID: number, locationId: number) {
        return this.http
            .get<EdgeRlMonitorConfiguration>(Config.urls.configureEdgeRl + `${customerID}` + `&locationId=${locationId}`)
            .pipe(
                map((result) => result),
                catchError(() => EMPTY),
            );
    }

    public edgeRlConfiguration(configuration: EdgeRlConfigurationPayload, customerID: number) {
        return this.http
            .post<ActivateLocationResponse>(Config.urls.configureEdgeRl + `${customerID}`, configuration)
            .pipe(
                map(
                    (result) => {
                        return result;
                    },
                    () => {
                        return EMPTY;
                    },
                ),
            );
    }

    public saveDynamicSection(deviceId: string, sensorData: unknown) {
        return this.http.post<void>(Config.urls.dynamicSensorConfig + deviceId, sensorData);
    }
}
